import { Door } from 'graphql/generated/graphqlTypes';
import { doorsWithLocationsVar } from 'state/vars';

export const setDoorWithLocationsAction = (doorsWithLocations: Door[]) => {
  doorsWithLocationsVar(doorsWithLocations);
};

export const updateDoorWithLocationsAction = (updatedDoorWithLocation: Door) => {
  const currentDoorWithLocations = doorsWithLocationsVar();
  const updatedDoorWithLocations = currentDoorWithLocations.map((group) =>
    group.id === updatedDoorWithLocation.id ? updatedDoorWithLocation : group
  );

  doorsWithLocationsVar(updatedDoorWithLocations);
};

export const deleteDoorWithLocationsAction = (deletedDoorWithLocationsId: string) => {
  const currentDoorWithLocations = doorsWithLocationsVar();
  const updatedDoorWithLocations = currentDoorWithLocations.filter((door) => door.id !== deletedDoorWithLocationsId);

  doorsWithLocationsVar(updatedDoorWithLocations);
};
